import { ILLBusinessCategory } from './business-category.model';

export class IContactDetail {
    contactName: string;
    contactId: string;
    contactRevisionId: string;
    businessCategory: ILLBusinessCategory;
    businessCategoryId: string;
    contactType: string;
    contactActiveFlag: string;
    version: string;
    parentVersion: string;
    formActiveFlag: string;
    status: string;
    isEstablishment: string;
    isImporter: string;
    isLabeler: string;
    isRegistrant: string;
    isUSAgent: string;

    dialCode: string;
    areaCode: string;
    phoneNumber: string;
    phoneExtension: string;

    firstName: string;
    lastName: string;
    email: string;
    address: string;
    city: string;
    countryId: string;
    countryRegion: string;
    zip: string;
    notes: string;
    activeFlagFormatted: string;
    activeFlag: string;
    isDraftMode: boolean;
    loAFlag: boolean;
}
